import * as React from "react";
import { SVGProps } from "react";

const Redd = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
    <path
      fill="#7CC245"
      d="M41.501 87.799 35.14 74.582 23.744 92.533a50.876 50.876 0 0 0 3.037 1.744 48.814 48.814 0 0 0 3.997 1.888 49.772 49.772 0 0 0 13.611 3.515c.975.108 1.958.188 2.947.242l-5.835-12.123z"
    />
    <path
      fill="#FCCB32"
      d="M98.18 36.637a48.88 48.88 0 0 0-1.076-3.361l-35.156 31.05-4.852 4.283.399 3.959 2.665 26.386a50.02 50.02 0 0 0 5.146-1.351C85.432 91.139 100 72.273 100 50c0-4.63-.643-9.107-1.82-13.363z"
    />
    <path
      fill="#EE3F26"
      d="m29.055 76.66 7.757 16.117 26.939-23.791-4.881-48.339z"
    />
    <path
      fill="#CF3627"
      d="m32.46 74.895 25.683-48.248.184 1.835 2.749-5.165-.002-.025-48.368 15.166 19.142 39.771 1.164-2.188z"
    />
    <path
      fill="#F05048"
      d="m39.142 88.777 5.247 10.9c1.843.208 3.713.323 5.611.323 5.34 0 10.48-.846 15.307-2.396l-2.961-29.317-23.204 20.49z"
    />
    <path
      fill="#FCCB32"
      d="m62.346 68.285 2.961 29.318C85.432 91.139 100 72.273 100 50c0-4.63-.643-9.107-1.82-13.363L62.346 68.285z"
    />
    <path
      fill="#2591D4"
      d="M55.48.305A50.29 50.29 0 0 0 50 0C32.166 0 16.523 9.345 7.672 23.397a49.887 49.887 0 0 0-5.308 11.454L15.64 39.95l42.5-13.325.016-.005 4.562-24.974A49.877 49.877 0 0 0 55.48.305z"
    />
    <path
      fill="#F47F22"
      d="M87.823 17.319A50.13 50.13 0 0 0 70.084 4.211a49.798 49.798 0 0 0-7.367-2.564l-4.562 24.974-.014.026 4.205 41.638L98.18 36.637a49.86 49.86 0 0 0-10.357-19.318z"
    />
    <path
      fill="#4CAA4C"
      d="M32.46 74.895 15.64 39.95 2.365 34.851A49.55 49.55 0 0 0 0 50c0 17.766 9.273 33.355 23.235 42.225a51.068 51.068 0 0 0 3.546 2.055l8.537-13.446-2.858-5.939z"
    />
    <path
      fill="#7CC245"
      d="m39.142 88.777-3.824-7.945-8.537 13.445a48.814 48.814 0 0 0 3.997 1.888 49.772 49.772 0 0 0 13.611 3.515l-5.247-10.903z"
    />
    <path
      fill="#F47F22"
      d="M87.823 17.319A50.13 50.13 0 0 0 70.084 4.211l-11.93 22.41 29.669-9.302zm-29.68 9.328 4.203 41.638L98.18 36.637a49.883 49.883 0 0 0-10.355-19.318l-29.668 9.302-.014.026z"
    />
    <path
      fill="#EE3F26"
      d="m32.46 74.895 6.682 13.882 23.204-20.492-4.203-41.638z"
    />
    <path
      fill="#1E85CA"
      d="M58.141 26.625 55.483.305A50.387 50.387 0 0 0 50 0C32.166 0 16.523 9.345 7.672 23.397L15.64 39.95l42.501-13.325z"
    />
    <path
      fill="#CF3627"
      d="M58.141 26.625 15.64 39.95l16.82 34.945 25.683-48.248z"
    />
    <path
      fill="#35A9E1"
      d="M58.154 26.621 70.084 4.21A49.667 49.667 0 0 0 55.48.305l2.658 26.32.016-.004z"
    />
    <path
      fill="#F05048"
      d="m39.142 88.777 5.247 10.9c1.843.208 3.713.323 5.611.323 5.34 0 10.48-.846 15.307-2.396l-2.961-29.317-23.204 20.49z"
    />
    <path
      fill="#FCCB32"
      d="m62.346 68.285 2.961 29.318C85.432 91.139 100 72.273 100 50c0-4.63-.643-9.107-1.82-13.363L62.346 68.285z"
    />
    <path
      fill="#7CC245"
      d="M30.778 96.165a49.772 49.772 0 0 0 13.611 3.515l-5.247-10.9-8.364 7.385z"
    />
    <path
      fill="#0161AD"
      d="M7.672 23.397A49.683 49.683 0 0 0 .273 44.768L15.64 39.95 7.672 23.397z"
    />
    <path
      fill="#4CAA4C"
      d="M15.64 39.95.273 44.768A50.804 50.804 0 0 0 0 50c0 17.766 9.273 33.355 23.235 42.225l9.225-17.33L15.64 39.95z"
    />
    <path
      fill="#51B34B"
      d="m32.46 74.895-9.225 17.33a49.636 49.636 0 0 0 7.542 3.94l8.364-7.388-6.681-13.882z"
    />
    <path
      fill="#444344"
      d="M59.195 10.994 58 14.5c10.416 5.642 20.512 15.676 25.994 24.419l3.589-1.081c-5.866-9.558-16.946-20.65-28.388-26.844z"
    />
    <path
      fill="#EE3F26"
      d="M76.566 2.871c-6.705 0-12.539 3.673-15.635 9.111a17.996 17.996 0 0 0-1.072 2.208c-.077.196-.139.398-.207.599-.062.182-.133.36-.189.543 9.379 5.46 18.322 14.28 23.68 22.285.08-.031.162-.054.241-.086a17.154 17.154 0 0 0 1.731-.838c.427-.234.848-.477 1.254-.741 4.932-3.21 8.199-8.756 8.199-15.079 0-9.942-8.058-18.002-18.002-18.002z"
    />
    <path
      fill="#C03225"
      d="M59.652 14.789c-.062.182-.133.36-.189.543 9.379 5.46 18.322 14.28 23.68 22.285.08-.031.162-.054.241-.086a17.154 17.154 0 0 0 1.731-.838c-5.692-7.963-15.441-16.77-25.463-21.904z"
    />
  </svg>
);

export default Redd;
